import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import * as io from "socket.io-client";
import {SOCKET} from "../enums/enums";
import {BusService} from "./bus.service";
import {ModalService} from "./modal.service";

@Injectable()
export class SockService {
  private socket: any;


  constructor(private busService: BusService,
              private modalService: ModalService) {
    this.socket = io();
    this.socket.on(SOCKET.BROADCAST, (data: any): void => this.handleBroadcast(data));
  }


  private handleBroadcast(data: ISocketMessage): void {
    switch (data.type) {

      case SOCKET.BROADCAST_TYPES.GOING_SHUTDOWN:
        this.modalService.showWarning("Админка скоро выключится - сохранись!");
        break;

      case SOCKET.BROADCAST_TYPES.DROP_ALL_LOCKS:
        this.modalService.showWarning("Все залоченные документы сброшены сервером! Обвнови страницу!");
        break;

      case SOCKET.BROADCAST_TYPES.TIMEOUT:
        let documentIds: string[] = <string[]>(data.deleted || []);
        this.busService.emitLocksTimedOut(documentIds);
        break;

      case SOCKET.BROADCAST_TYPES.PACK_STARTED: // do i need this type of event?
        this.busService.emitTexturePackerIsBusy(true);
        break;

      case SOCKET.BROADCAST_TYPES.PACK_FINISHED: // do i need this type of event?
        this.busService.emitTexturePackerIsBusy(false);
        break;
    }

    // todo: handle event, if cannot -> send further (this.busService.emitSocketBroadcast(data))
  }


  sendEvent(type: string,
            data: any) {
    let subject = new Subject<any>();

    data.type = type;
    this.socket.emit("message", data, (r: any): void => {
      //console.log(r);
      subject.next(r);
    });
    return subject.asObservable();
  }
}


export interface ISocketMessage {
  type: string;
  deleted?: string[]; //
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/sock.service.ts